import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import toast from 'react-hot-toast';

import { addProduct, updateProduct } from '../../actions/product';
import ModalWrapper from '../ModalWrapper/ModalWrapper';
import ImageInput from '../ImageInput/ImageInput';
import styles from './ProductModal.module.css';

const ProductModal = (props) => {
  const { 
    initialValue, 
    isOpen, 
    onClose,
    addProduct,
    updateProduct,
    productsData,
    categoriesData,
  } = props;

  // console.log('===PRODUCT MODAL', initialValue);
  // console.log('===productsData', productsData);

  const [name, setName] = useState('');  
  const [packageWeight, setPackageWeight] = useState(''); 
  const [Link, setLink] = useState('');
  const [image, setImage] = useState('');
  const [categoryId, setCategoryId] = useState('');
  // const [unitSale, setUnitSale] = useState('piece');

  useEffect(() => {
    if (initialValue) {
      setName(initialValue?.name);
      setLink(initialValue?.link);
      setPackageWeight(initialValue?.package_weight);
      setImage(initialValue?.image);
      setCategoryId(initialValue?.category_id);
      // setUnitSale(initialValue?.unit_sale);
    }
  }, [isOpen, initialValue, productsData]);

  const title = initialValue ? 'Edit product' : 'Add new product';

  const changeValueHandler = setter => event => {
    setter(event.target.value);
  };


  const changeImageHandler = (imageData) => {
    // console.log('===CHANGE IMAGE', imageData);
    setImage(imageData);
  };

  // console.log('===image', image);

  const onSaveHandler = () => {
    const trimmedName = name.trim();
    if (!trimmedName) {
      return toast.error('Name is required', {
        position: 'bottom-right',
        duration: 3000,
      });
    }

    if (!packageWeight) {
      return toast.error('Package weight is required', {
        position: 'bottom-right',
        duration: 3000,
      }); 
    }

    if (!categoryId) {
      return toast.error('Category is required', {
        position: 'bottom-right',
        duration: 3000,
      }); 
    }

    // if (!unitSale) {
    //   return toast.error('Unit sale is required', {
    //     position: 'bottom-right',
    //     duration: 3000,
    //   }); 
    // }

    // Check if there is an product with the same name and unit type
    const existenceProduct = productsData.find(product => {
      if (product.name !== trimmedName) {
        return false;
      }

      return initialValue?.id !== product.id;
    });

    if (existenceProduct) {
      return toast.error('Product with this name already exists', {
        position: 'bottom-right',
        duration: 3000,
      }); 
    }

    console.log('===Link', Link);

    const productData = {
      name: trimmedName,
      link: Link?.trim() || '',
      package_weight: packageWeight,
      image,
      category_id: categoryId,
      // unit_sale: 'gram',
    };

    // if (unitSale === 'gram') {
    //   productData.package_weight = packageWeight;
    // }

    let saveProduct = addProduct;

    if (initialValue) {
      productData.id = initialValue.id;
      saveProduct = updateProduct;
    }

    saveProduct(productData, onClose);

    // onClose();
  };

  return (
    <ModalWrapper 
      key={initialValue?.id}
      isOpen={isOpen} 
      onClose={onClose} 
      onSave={onSaveHandler} 
      title={title}
    >
      <div className={styles.wrapper}>
        <label className={styles.row}>
          <span>Product name</span>
          <input 
            className={styles.input} 
            onChange={changeValueHandler(setName)}
            placeholder="Product name"
            value={name}
          />
        </label>
        <label className={styles.row}>
          <span>Link</span>
          <input 
            className={styles.input} 
            onChange={changeValueHandler(setLink)}
            placeholder="Link"
            value={Link}
          />
        </label>
        <div className={styles.dishImages}>
          <div className={styles.dishImagesTitle}>
            Product image
          </div>
          <ImageInput 
            key={initialValue?.id}
            value={image}
            onChange={changeImageHandler}
            name="image"
            label="Upload"
          />
        </div>
        {/* <label className={styles.row}>
          <span>Unit of sale</span>
          <select 
            className={styles.select} 
            onChange={changeValueHandler(setUnitSale)}
            value={unitSale}
          >
            <option value="piece">By piece</option>
            <option value="gram">In grams</option>
          </select>
        </label> */}
        <label className={styles.row}>
          <span>Package weight</span>
          <input 
            className={styles.input} 
            onChange={changeValueHandler(setPackageWeight)}
            placeholder="Package weight"
            value={packageWeight}
            type="number"
          />
        </label>
        <label className={styles.row}>
          <span>Category</span>
          <select 
            className={styles.select} 
            onChange={changeValueHandler(setCategoryId)}
            value={categoryId}
          >
            <option value="" disabled>Select category</option>
            {categoriesData.map((categoryData) => (
              <option key={categoryData.id} value={categoryData.id}>
                {categoryData.name}
              </option>
            ))}
          </select>
        </label>
      </div>
    </ModalWrapper>
  );
};

const mapStateToProps = (store) => ({
  productsData: store.product.productsData,
});

const mapDispatchToProps = {
  addProduct,
  updateProduct,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductModal);